import { Captcha, RainbowButton } from '@/components';
import { useId, useState } from 'react';
import { useReward } from 'react-rewards';
import { ShinningText } from '../ShinningText/ShinningText.component';
import { CONTACT_EMAIL, REWARD_CONFIG } from './EmailDiscover.consts';
import classes from './EmailDiscover.module.css';
import { ButtonStatus, type Props } from './EmailDiscover.types';

export const EmailDiscover = ({ onEmailDiscover }: Props) => {
  const confettiId = useId();
  const { reward } = useReward(confettiId, 'emoji', REWARD_CONFIG);
  const [isCaptchaResolved, setIsCaptchaResolved] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(ButtonStatus.default);

  const isButtonDefault = buttonStatus === ButtonStatus.default;
  const isButtonClicked = buttonStatus === ButtonStatus.clicked;

  const handleGetEmailButtonClick = () => {
    setButtonStatus(ButtonStatus.clicked);
  };

  const handleClipboardButtonClick = () => {
    navigator.clipboard.writeText(CONTACT_EMAIL);
    reward();
  };

  const handleCaptchaSuccess = () => {
    setButtonStatus(ButtonStatus.hidden);
    setIsCaptchaResolved(true);
    onEmailDiscover?.();
  };

  return (
    <div className={classes.container}>
      {isButtonDefault ? (
        <RainbowButton
          className={classes.button}
          onClick={handleGetEmailButtonClick}
        >
          Get my email
        </RainbowButton>
      ) : null}
      {isCaptchaResolved ? (
        <>
          <ShinningText className={classes.email} text={CONTACT_EMAIL} />
          <div>
            <RainbowButton
              className={classes.button}
              onClick={handleClipboardButtonClick}
            >
              📋 Copy to Clipboard
            </RainbowButton>
            <span className={classes.confetti} id={confettiId} />
          </div>
        </>
      ) : null}
      {isButtonClicked ? <Captcha onSuccess={handleCaptchaSuccess} /> : null}
    </div>
  );
};
